import {is_mobile, is_tablet, is_desktop_small, is_fhd} from './utils'

//
// Sequence options
//

let canvasDensity = Math.min(2, window.devicePixelRatio);

let bikeFrameOptions = {
  baseURL: process.env.MIX_AWS_URL + "assets/images/frame/Frame Only",
  ratio: 1716 / 965, // ratio is important, you can directly pass ratio of image's height and width
  extension: ".jpg",
  frameCount: 91, // total number of frames before creating sprites
  lastFrame: "last.jpg", // lastpart of last frame with extension will create frame_lastframe.jpg
  numberPadding: 2, // number of zeros on original file, will be used to access each frame
}

let bikeFrameOptionsSc = {
  baseURL: process.env.MIX_AWS_URL + "assets/images/aryon-sc/rotate/ARYONSC_ROTATE_",
  ratio: 1920 / 1080, // ratio is important, you can directly pass ratio of image's height and width
  extension: ".jpg",
  frameCount: 43, // total number of frames before creating sprites
  lastFrame: "042.jpg", // lastpart of last frame with extension will create frame_lastframe.jpg
  numberPadding: 3, // number of zeros on original file, will be used to access each frame
}

let siryon_frame_options = {
  baseURL: process.env.MIX_AWS_URL + "assets/images/siryon/frame_final/SFRAME_",
  ratio: 1920 / 1080,
  extension: ".jpg",
  frameCount: 179,
  firstFrame: "000.jpg",
  lastFrame: "180.jpg",
  numberPadding: 3,
}

let cyon_frame_options = {
  baseURL: process.env.MIX_AWS_URL + "assets/images/cyon/frame_seq/TRAIL_",
  ratio: 1920 / 1080,
  extension: ".jpg",
  frameCount: 179,
  firstFrame: "000.jpg",
  lastFrame: "180.jpg",
  numberPadding: 3,
}

let hydra_frame_options = {
  baseURL: process.env.MIX_AWS_URL + "assets/images/hydra/frame_desktop/HYDRA_DESKTOP_",
  ratio: 1920 / 1080,
  extension: ".jpg",
  frameCount: 179,
  firstFrame: "000.jpg",
  lastFrame: "180.jpg",
  numberPadding: 3,
}

let motor_options = {
  baseURL: process.env.MIX_AWS_URL + "assets/images/motor/large/Motor",
  ratio: 1920 / 1080,
  frameCount: 301,
  extension: ".jpg",
  firstFrame: "00000.jpg",
  lastFrame: "Frame.png",
  numberPadding: 5,
}

let siryon_colors_options = {
  baseURL: process.env.MIX_AWS_URL + "assets/images/siryon/uoc_final/UOCFINAL_",
  ratio: 1920 / 1080,
  frameCount: 543,
  extension: ".jpg",
  firstFrame: "000.jpg",
  lastFrame: "542.jpg",
  numberPadding: 3,
}

let hydra_colors_options = {
  baseURL: process.env.MIX_AWS_URL + "assets/images/hydra/universe_of_colors/HYDRA_UOC",
  ratio: 1920 / 1080,
  frameCount: 369,
  extension: ".jpg",
  firstFrame: "000.jpg",
  lastFrame: "367.jpg",
  numberPadding: 3,
}

let sc_frame_options = {
  baseURL: process.env.MIX_AWS_URL + "assets/images/aryon-sc/frame_desktop/SC_DESKTOP_",
  ratio: 1920 / 1080,
  frameCount: 181,
  extension: ".jpg",
  firstFrame: "000.jpg",
  lastFrame: "180.jpg",
  numberPadding: 3,
}

let cyon_colors_options = {
  baseURL: process.env.MIX_AWS_URL + "assets/images/cyon/uoc/TRAIL_UOC",
  ratio: 1920 / 1080,
  frameCount: 551,
  extension: ".jpg",
  firstFrame: "000.jpg",
  lastFrame: "550.jpg",
  numberPadding: 3,
}

let battery_options = {
  baseURL: process.env.MIX_AWS_URL + "assets/images/battery/Battery",
  ratio: 1920 / 1080,
  extension: ".jpg",
  frameCount: 240,
  firstFrame: "000.jpg",
  lastFrame: "Last.jpg",
  numberPadding: 3,
}

let belt_options = {
  baseURL: process.env.MIX_AWS_URL + "assets/images/city/belt/B",
  ratio: 1920 / 1080,
  extension: ".jpg",
  frameCount: 144,
  firstFrame: "000.jpg",
  lastFrame: "Final.jpg",
  numberPadding: 3,
}

let home_top_banner = {
  baseURL: process.env.MIX_AWS_URL + "assets/images/home/banners/min/UOCFINAL_",
  ratio: 2200 / 1000,
  extension: ".jpg",
  frameCount: 59,
  firstFrame: "000.jpg",
  lastFrame: "060.jpg",
  numberPadding: 3,
}

// uncomment following code to support different screen sizes
// change sprite url
if (is_mobile && window.devicePixelRatio === 1) {
  // this block will load images for mobile devices that don't have high pixel density
  //bikeFrameOptions.baseURL = "assets/images/frame/sd/frame_";

  siryon_frame_options.baseURL = process.env.MIX_AWS_URL + "assets/images/siryon/frame_mob_seq/FRAMEM_"
  siryon_frame_options.ratio = 1280 / 720

  hydra_frame_options.baseURL = process.env.MIX_AWS_URL + "assets/images/hydra/frame_mobile/HYDRA_MOBILE_"
  hydra_frame_options.ratio = 1280 / 720

  sc_frame_options.baseURL = process.env.MIX_AWS_URL + "assets/images/aryon-sc/frame_mobile/SC_MOBILE_"
  sc_frame_options.ratio = 1280 / 720

  cyon_frame_options.baseURL = process.env.MIX_AWS_URL + "assets/images/cyon/frame_seq_mobile/CYON_MOBILE_"
  cyon_frame_options.ratio = 1280 / 720

  motor_options.baseURL = process.env.MIX_AWS_URL + "assets/images/motor/sd/Motor";
} else if (is_mobile && window.devicePixelRatio > 1 || is_tablet) {
  // this block will load images for mobile devices with high pixel density and tablets
  // keep canvas density to one for tablet
  if (is_tablet) canvasDensity = 1;

  siryon_frame_options.baseURL = process.env.MIX_AWS_URL + "assets/images/siryon/frame_mob_seq/FRAMEM_"
  siryon_frame_options.ratio = 1280 / 720

  hydra_frame_options.baseURL = process.env.MIX_AWS_URL + "assets/images/hydra/frame_mobile/HYDRA_MOBILE_"
  hydra_frame_options.ratio = 1280 / 720

  sc_frame_options.baseURL = process.env.MIX_AWS_URL + "assets/images/aryon-sc/frame_mobile/SC_MOBILE_"
  sc_frame_options.ratio = 1280 / 720

  cyon_frame_options.baseURL = process.env.MIX_AWS_URL + "assets/images/cyon/frame_seq_mobile/CYON_MOBILE_"
  cyon_frame_options.ratio = 1280 / 720

  // bikeFrameOptions.baseURL = "assets/images/frame/md/frame_";

  motor_options.baseURL = process.env.MIX_AWS_URL + "assets/images/motor/md/Motor";
} else if (is_desktop_small) {
  // this block will load images for small desktops. You can add more conditions to support different sizes.

  motor_options.baseURL = process.env.MIX_AWS_URL + "assets/images/motor/hd/Motor";
} else if (is_fhd) {
  motor_options.baseURL = process.env.MIX_AWS_URL + "assets/images/motor/fhd/Motor";
}

export {
  bikeFrameOptions,
  bikeFrameOptionsSc,
  siryon_frame_options,
  siryon_colors_options,
  cyon_colors_options,
  motor_options,
  battery_options,
  cyon_frame_options,
  belt_options,
  home_top_banner,
  hydra_colors_options,
  hydra_frame_options,
  sc_frame_options
}
